import { createSelector } from 'reselect'

import { uniqBy } from 'util/arrays'

import selectGitHubRepositories from './selectGitHubRepositories'

export default createSelector(selectGitHubRepositories, repositories =>
  uniqBy(repositories, ({ owner: { id } }) => id).map(({ owner }) => owner)
)
